<template>
  <section>
    <h2 class="hdg_order01"><i></i>品番変換マスタ</h2>
    <table class="table table-bordered bg-white tbl_master01">
      <tbody>
        <tr>
          <th class="bg-tbl-light">お客様品番CD</th>
          <td>
            <input
              type="text"
              class="form-control"
              v-model="searchClientItem_cd"
            />
          </td>
          <th class="bg-tbl-light">お客様品番名</th>
          <td>
            <input
              type="text"
              class="form-control"
              v-model="searchUserpart_na"
            />
          </td>
          <th class="bg-tbl-light">お客様規格名</th>
          <td>
            <input
              type="text"
              class="form-control"
              v-model="searchUserstand_na"
            />
          </td>
          <th class="bg-tbl-light">お客様色名</th>
          <td>
            <input
              type="text"
              class="form-control"
              v-model="searchUsercolor_na"
            />
          </td>
        </tr>
        <tr>
          <th class="bg-tbl-light">Nitto品番名</th>
          <td>
            <input type="text" class="form-control" v-model="searchPart_na" />
          </td>
          <th class="bg-tbl-light">Nitto規格名</th>
          <td>
            <input type="text" class="form-control" v-model="searchStand_na" />
          </td>
          <th class="bg-tbl-light">Nitto色名</th>
          <td>
            <input type="text" class="form-control" v-model="searchColor_na" />
          </td>
          <th class="bg-tbl-light">Nitto品番CD</th>
          <td>
            <input type="text" class="form-control" v-model="searchPart_cd" />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="btn-center">
      <button
        type="button"
        @click="searchConvertItemHandler"
        class="btn btn-order btn-lg"
      >
        検索
      </button>
    </div>

    <div v-if="searchErrorResponse.message" class="alert alert-danger mt-3">
      {{ searchErrorResponse.message }}
    </div>

    <template v-if="isSearchResult">
      <h2 class="hdg_order01 mt40"><i></i>変換品番マスタ一覧</h2>
      <div class="mb-3 d-flex justify-content-end">
        <bs-pagination
          :page.sync="page"
          :per-page="per_page"
          :number="searchResultLength"
        ></bs-pagination>
      </div>
      <div class="table-responsive mb-4">
        <table class="table table-bordered bg-white data_table text-nowrap">
          <thead>
            <tr class="bg-tbl-head text-white text-center">
              <th></th>
              <th style="min-width: 10em">お客様CD</th>
              <th style="min-width: 10em">お客様<br />品番名</th>
              <th style="min-width: 10em">お客様<br />規格名</th>
              <th style="min-width: 10em">お客様<br />色名</th>
              <th style="min-width: 10em">お客様<br />単位</th>
              <th style="min-width: 10em">Nitto<br />部署CD</th>
              <th style="min-width: 10em">Nitto<br />品番CD</th>
              <th style="min-width: 10em">Nitto<br />規格CD</th>
              <th style="min-width: 10em">Nitto<br />色CD</th>
              <th style="min-width: 10em">Nitto<br />品番名</th>
              <th style="min-width: 10em">Nitto<br />規格名</th>
              <th style="min-width: 10em">Nitto<br />色名</th>
              <th style="min-width: 10em">Nitto<br />単位</th>
              <th style="min-width: 10em">Nitto<br />入り数</th>
              <th style="min-width: 10em">Nitto<br />梱包数</th>
              <th style="min-width: 10em">Nitto<br />掛数</th>
              <th style="min-width: 10em">Nitto<br />割数</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="text-center"
              v-for="item in filteredsearchResults"
              :key="item.row_no"
            >
              <td>
                <button
                  class="btn btn-primary btn-sm"
                  @click="getConvertItemInfoHandler(item)"
                >
                  選択
                </button>
              </td>
              <td>{{ item.clientitem_cd }}</td>
              <td>{{ item.userpart_na }}</td>
              <td>{{ item.userstand_na }}</td>
              <td>{{ item.usercolor_na }}</td>
              <td>{{ item.userunit_na }}</td>
              <td>{{ item.cdcredept_di }}</td>
              <td>{{ item.part_cd }}</td>
              <td>{{ item.stand_cd }}</td>
              <td>{{ item.color_cd }}</td>
              <td>{{ item.part_na }}</td>
              <td>{{ item.stand_na }}</td>
              <td>{{ item.color_na }}</td>
              <td>{{ item.unit_na }}</td>
              <td>{{ item.ir_qt }}</td>
              <td>{{ item.pickunit_qt }}</td>
              <td>{{ item.multiply_qt }}</td>
              <td>{{ item.division_qt }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <template v-if="isDetailResult">
      <h2 id="detail" class="hdg_order01"><i></i>変換マスタ　詳細</h2>
      <table class="table table-bordered bg-white tbl_master02">
        <thead>
          <tr class="bg-tbl-head">
            <th>項目</th>
            <th>お客様データ</th>
            <th>日東側データ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="bg-tbl-light">お客様品番CD</th>
            <td>{{ convertItem.clientitem_cd }}</td>
            <td class="bg-tbl-blue">{{ convertItem.item_cd }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">品番名</th>
            <td>{{ convertItem.userpart_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.part_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">規格名</th>
            <td>{{ convertItem.userstand_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.stand_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">色名</th>
            <td>{{ convertItem.usercolor_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.color_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">単位</th>
            <td>{{ convertItem.userunit_na }}</td>
            <td class="bg-tbl-blue">{{ convertItem.unit_na }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">入り数</th>
            <td>{{ convertItem.userir_qt }}</td>
            <td class="bg-tbl-blue">{{ convertItem.ir_qt }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">梱包単位数</th>
            <td>{{ convertItem.userpickunit_qt }}</td>
            <td class="bg-tbl-blue">{{ convertItem.pickunit_qt }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">掛け数</th>
            <td></td>
            <td class="bg-tbl-blue">{{ convertItem.multiply_qt }}</td>
          </tr>
          <tr>
            <th class="bg-tbl-light">割数</th>
            <td></td>
            <td class="bg-tbl-blue">{{ convertItem.division_qt }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </section>
</template>

<script>
import {
  // store as loginUser,
  mutations as loginUserMutations
} from "../../../../store/LoginUser";

export default {
  data() {
    return {
      // Search Field
      searchClientItem_cd: "",
      searchUserpart_na: "",
      searchUserstand_na: "",
      searchUsercolor_na: "",
      searchPart_na: "",
      searchStand_na: "",
      searchColor_na: "",
      searchCdcredept_di: "",
      searchPart_cd: "",
      searchStand_cd: "",
      searchColor_cd: "",

      // Result
      isSearchResult: false,
      searchErrorResponse: {},
      convertItemList: [],

      page: 1,
      per_page: 10,

      isDetailResult: false,
      detailErrorResponse: {},
      convertItem: null
    };
  },
  computed: {
    searchResultLength() {
      return this.convertItemList.length;
    },
    filteredsearchResults() {
      const from = (this.page - 1) * this.per_page;
      const to = from + this.per_page;
      return this.convertItemList.slice(from, to);
    }
  },
  async beforeMount() {
    const response = await this.getInitDataHandler();
    if (response.responseData.return != "0") {
      this.redirectToLogin();
      return;
    }

    // Set Login User Info
    loginUserMutations.setUserInfo(
      this.getAsteriaFirst(response.responseData, "loginUserInfoData")
    );
  },
  methods: {
    /**
     * Get initial data from ASTERIA
     */
    async getInitDataHandler() {
      const response = await this.postAsteria("FileOrder", "getInitData");

      return response;
    },

    async searchConvertItemHandler() {
      this.page = 1;
      this.isSearchResult = false;
      this.isDetailResult = false;
      this.searchErrorResponse = {};

      const response = await this.postAsteria(
        "FileOrder",
        "searchConvertItem",
        {
          searchClientItem_cd: this.searchClientItem_cd,
          searchUserpart_na: this.searchUserpart_na,
          searchUserstand_na: this.searchUserstand_na,
          searchUsercolor_na: this.searchUsercolor_na,
          searchPart_na: this.searchPart_na,
          searchStand_na: this.searchStand_na,
          searchColor_na: this.searchColor_na,
          searchCdcredept_di: this.searchCdcredept_di,
          searchPart_cd: this.searchPart_cd,
          searchStand_cd: this.searchStand_cd,
          searchColor_cd: this.searchColor_cd
        }
      );

      if (response.responseData.return != 0) {
        this.searchErrorResponse = response.responseData;
        return;
      }

      this.isSearchResult = true;
      this.convertItemList = this.getAsteriaArray(
        response.responseData,
        "convertItemList"
      );
      return response;
    },
    async getConvertItemInfoHandler(item) {
      this.isDetailResult = false;
      this.detailErrorResponse = {};

      const response = await this.postAsteria(
        "FileOrder",
        "getConvertItemInfo",
        {
          searchClientitem_cd: item.clientitem_cd,
          searchCdcredept_di: item.cdcredept_di,
          searchPart_cd: item.part_cd,
          searchStand_cd: item.stand_cd,
          searchColor_cd: item.color_cd
        }
      );

      if (response.responseData.return != 0) {
        // this.detailErrorResponse = response.responseData;
        window.alert(response.responseData.message);
        return;
      }

      this.isDetailResult = true;
      this.convertItem = this.getAsteriaFirst(
        response.responseData,
        "convertItem"
      );

      this.$nextTick(() => {
        const target = document.querySelector("#detail");

        // target.scrollIntoView({
        //   behavior: "smooth",
        //   block: "center"
        // });
        this.$perfectScrollbar.scrollTo(target);
      });
    }
  }
};
</script>
